export const redirectToSuccess = () => {
  const searchParams = new URLSearchParams(window.location.search);
  const isCheckout = searchParams.get('isCheckout');

  if (isCheckout) {
    // eslint-disable-next-line no-restricted-globals
    parent.postMessage({ message: 'checkoutSuccess' }, '*');
  } else {
    // eslint-disable-next-line no-restricted-globals
    parent.postMessage({ message: 'success' }, '*');
  }
};

export const redirectToDecline = (navigate?: any): void => {
  const searchParams = new URLSearchParams(window.location.search);
  const isCheckout = searchParams.get('isCheckout');

  // if (isCheckout && navigate) {
  //   // navigate('/decline');
  // } else if (isCheckout) {
  //   // window.location.href = `${window.location.origin}/decline`;
  // }
  if (isCheckout) {
    // eslint-disable-next-line no-restricted-globals
    parent.postMessage({ message: 'checkoutDecline' }, '*');
  } else {
    // TODO uncomment
    // eslint-disable-next-line no-restricted-globals
    parent.postMessage({ message: 'decline' }, '*');
  }
};

export const redirect = (link: string, target?: string): void => {
  // eslint-disable-next-line no-restricted-globals
  parent.postMessage({ message: 'autoRedirect', link, target: target || '_self' }, '*');
};

export const closeModal = () => {
  // eslint-disable-next-line no-restricted-globals
  parent.postMessage({ message: 'close' }, '*');
};
